import { Checkbox, Stack, Typography, Box } from '@mui/material';
import { forwardRef } from 'react';
import theme from '../../theme';

const CustomCheckbox = forwardRef(
  ({ error, helperText, label, secondLabel, ...restProps }, ref) => {
    return (
      <Stack>
        <Stack direction="row" alignItems="flex-start" gap={0.5}>
          <Checkbox
            inputRef={ref}
            {...restProps}
            sx={{
              padding: 0,
              '& .MuiSvgIcon-root': { fontSize: '18px' },
              color: theme.palette.grey.line,
              '&.Mui-checked': {
                color: theme.palette.secondary.main,
              },
            }}
          />
          <Box>
            <Typography
              color={theme.palette.black[9]}
              sx={{
                fontSize: '14px',
                lineHeight: 'normal',
                display: { lg: 'block', md: 'inline', xs: 'inline' },
                whiteSpace: 'pre-line',
              }}
            >
              {label}
            </Typography>
            {secondLabel && (
              <Typography
                color={theme.palette.black[4]}
                sx={{
                  fontSize: '14px',
                  lineHeight: 'normal',
                  display: { lg: 'block', md: 'inline', xs: 'inline' },
                  whiteSpace: 'pre-line',
                  marginLeft: { lg: 0, md: 0.5, xs: 0.5 },
                }}
              >
                {secondLabel}
              </Typography>
            )}
          </Box>
        </Stack>
        {helperText && (
          <Typography variant="caption" color="error">
            {helperText}
          </Typography>
        )}
      </Stack>
    );
  },
);

export default CustomCheckbox;
